/**
 * Created by Jew on 6/16/2017.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {IdexService} from 'app/idex.service';
import {DocListComponent} from '../doclist/doclist.component';
import {ConfirmRestoreComponent} from '../confirm-restore/confirm-restore.component';
import {ConfirmPermanentDeleteComponent} from '../confirm-permanent-delete/confirm-permanent-delete.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-trash',
   templateUrl: './trash.component.html',
   styleUrls: ['./trash.component.css']
})
export class TrashComponent implements OnInit {
   @ViewChild(DocListComponent, {static: true})
   public docList: DocListComponent;
   private skip = 0;
   private take = 50;
   selectedItems: any[] = [];

   constructor(private service: IdexService, public dialog: MatDialog,
               private translate: TranslateService, private toast: Toast) {
   }

   ngOnInit(): void {
      sessionStorage.removeItem('shared');
      this.loadMore();
   }

   loadMore(): void {
      this.service.openTrash(this.skip, this.take)
         .subscribe(data => {
            if (this.skip === 0) {
               this.docList.setItems(data.items, data.hasMore);
            } else {
               this.docList.addItems(data.items, data.hasMore);
            }
            this.skip += this.take;
         });
   }

   onItemAllSelect(chk: any) {
      for (let i = 0; i < this.docList.items.length; i++) {
         this.docList.items[i].selected = chk.checked;
         const index = this.selectedItems.indexOf(this.docList.items[i]);
         if (this.docList.items[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.docList.items[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   confirmRestore() {
      const dialogRef = this.dialog.open(ConfirmRestoreComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
            this.docList.item = [];
            this.skip = 0;
            this.loadMore();
         }
      });
   }

   confirmPermanentDelete(): void {
      const dialogRef = this.dialog.open(ConfirmPermanentDeleteComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
            this.docList.item = [];
            this.skip = 0;
            this.loadMore();
         }
      });
   }
   /*for DeleteAll button*/
   confirmPermanentDeleteAll(): void {
      if (this.docList.items.length) {
         const dialogRef = this.dialog.open(ConfirmPermanentDeleteComponent, {
            disableClose: true,
            data: {
               service: this.service, listItem: this.docList.items, trashEmpty: true,
               isMultiSelect: true, data: this, toast: this.toast, translate: this.translate,
            }
         });
         dialogRef.afterClosed().subscribe(result => {
            if (result) {
               this.selectedItems = [];
               this.docList.item = [];
               this.skip = 0;
               this.loadMore();
            }
         });
      }
   }
}
